<template>
    <div class="resourceLibrary ">
        <div class="left">
            <el-tree style="max-width: 600px" :data="data" class="resourceLibrary-tree" @node-click="handleNodeClick" />
        </div>
        <div class="right">
            <div class="imagecont">
                <myUpload :id="folderActiveId" ref="myUploadRef" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ElTree } from 'element-plus'
import { ref, onMounted } from 'vue'
import { createFolder, getFolderList } from '@/api/affairs'
// @ts-ignore
import myUpload from './myUpload.vue'
const folderActiveId = ref('')
const data = ref([
    {
        id: '',
        label: '我的空间',
        children: [

        ],
    },
    {
        id: 1,
        label: '我的字体',
        children: [

        ],
    },
])
onMounted(() => {
    getResourceLibrary('', '')
})
const getResourceLibrary = (id, node) => {
    getFolderList({ parent_folder_id: id || '' }).then(res => {
        if (id == '') {
            data.value[0].children = res.data.data.map(item => ({
                id: item.id,
                label: item.name,
                children: []
            }))
        } else {
            node.children = res.data.data.map(item => ({
                id: item.id,
                label: item.name,
                children: []
            }))
        }
    })
}
const handleNodeClick = (node) => {
    getResourceLibrary(node.id, node)
    folderActiveId.value = node.id
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.resourceLibrary {
    height: 700px;
    width: 100%;
    display: flex;
    border-top: 1px solid #e5e5e5;

    .left {
        height: 100%;
        width: 200px;
        border-right: 1px solid #e5e5e5;
    }

    .right {
        height: 100%;
        width: calc(100% - 200px);
    }
}

.resourceLibrary-tree {
    height: 100%;
    border: none;

}
</style>
<style>
.el-tree-node {
    border: none !important;
    font-size: 14px;
    color: #303133;
    width: 100%;
}

.el-tree-node__content {
    width: 100% !important;
    height: 50px !important;
}
</style>
